"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
var isBrowser = function () { return typeof window !== 'undefined'; };
exports.isBrowser = isBrowser;
//# sourceMappingURL=browser.js.map